import { createAction } from 'typesafe-actions';

import { ValuationState } from './index';

export type UpdateValuationDatesStateFromFormPayload = {
  data: Partial<ValuationState>;
};
export const updateValuationDatesStateFromForm = createAction(
  'pricer/valuation/updateValuationDatesStateFromForm',
)<UpdateValuationDatesStateFromFormPayload>();
